import { AxiosInstance } from 'axios';

function getYearsForCharts(api: AxiosInstance) {
  return () => api.get<number[]>(`/available-years-for-charts`);
}

export default getYearsForCharts;
